module.exports = __webpack_public_path__ + "img/02_Akademie_Licht.32fccf33.jpg";